import React from 'react';

import {SalesLinkEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {translations} from 'presentation/translations-new';
import contractNowImgApp from 'presentation/assets/images/contract-now-app.webp';
import contractNowImgDesktop from 'presentation/assets/images/contract-now-desktop.webp';
import {useMediaQueries} from 'presentation/pages/private/hooks/useMediaQueries';
import {PerksTaggingEnum} from 'main/analytics/gaTagsEnum';
import {PerksCard} from '../PerksCard';

const {title, description, action} = translations['pt-br'].privateFlow.perks.contractNow;

export function ContractNow() {
	const {isMobile} = useMediaQueries();
	const {
		dataHostNameState: {product},
	} = useHostName();

	const salesUrl = SalesLinkEnum[product];
	const image = isMobile ? contractNowImgApp : contractNowImgDesktop;

	const handleClick = () => {
		window.open(salesUrl, '_blank');
	};

	return (
		<PerksCard
			dataTagId={PerksTaggingEnum.CLICK_CONTRATE_ONLINE_BENEFICIOS}
			cardImage={image}
			description={description}
			title={title}
			handleAction={handleClick}
			buttonText={action}
			isLoading={false}
		/>
	);
}
